// extracted by mini-css-extract-plugin
export var menuIcon = "_p2-0";
export var menuIconInline = "_p2-1";